import React from 'react';
import { Edit3, X } from 'lucide-react';
import { SmallText } from '../../../components/brand/BrandTypography';
import { IconButton, PrimaryButton, TertiaryButton } from '../../../components/brand/BrandButton';

const ScriptsTab = ({ scripts, editingScript, setEditingScript, onSave }) => {
    return (
        <div className="space-y-4">
            <div className="mb-4 p-4 bg-[#7D8E95]/20 rounded-xl border border-[#7D8E95]/20">
                <SmallText className="text-[#7D8E95]">
                    <strong>Cycle Breaking Scripts</strong> - Click on any script to edit it. Pre-written scripts to help users break negative relationship cycles.
                </SmallText>
            </div>
            {['general', 'pursuer', 'withdrawer'].map(role => {
                const roleScripts = scripts.filter(s => s.role === role);
                if (roleScripts.length === 0) return null;
                return (
                    <div key={role} className="mb-6">
                        <h3 className="text-sm font-medium text-[#7D8E95] uppercase tracking-wider mb-3 flex items-center gap-2">
                            <span className={`w-2 h-2 rounded-full ${
                                role === 'general' ? 'bg-[#1D6B6B]' :
                                role === 'pursuer' ? 'bg-[#FFBB98]' : 'bg-[#7D8E95]'
                            }`} />
                            {role === 'general' ? 'General Scripts' : role === 'pursuer' ? 'For Pursuers' : 'For Withdrawers'}
                        </h3>
                        <div className="space-y-3">
                            {roleScripts.map(script => (
                                <div 
                                    key={script.script_id} 
                                    className="bg-white rounded-xl border border-[#FFBB98] p-4 cursor-pointer hover:border-[#7D8E95]/50 transition-colors"
                                    onClick={() => setEditingScript({...script})}
                                >
                                    <div className="flex items-start gap-3">
                                        <div className="flex-1">
                                            <p className="text-[#1D6B6B] italic mb-2">"{script.text}"</p>
                                            <span className="text-xs text-[#7D8E95]">{script.context}</span>
                                        </div>
                                        <Edit3 className="w-4 h-4 text-[#7D8E95] flex-shrink-0 mt-1" />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                );
            })}
            
            {editingScript && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto p-6">
                        <div className="flex items-center justify-between mb-4">
                            <h3 className="text-lg font-medium">Edit Script</h3>
                            <IconButton onClick={() => setEditingScript(null)}>
                                <X className="w-5 h-5" />
                            </IconButton>
                        </div>
                        <div className="space-y-4">
                            <div>
                                <label className="text-sm text-[#7D8E95] mb-1 block">Script Text</label>
                                <textarea 
                                    value={editingScript.text} 
                                    onChange={(e) => setEditingScript({...editingScript, text: e.target.value})}
                                    className="w-full p-3 border border-[#FFBB98] rounded-xl"
                                    rows={4}
                                />
                            </div>
                            <div>
                                <label className="text-sm text-[#7D8E95] mb-1 block">Context</label>
                                <input 
                                    value={editingScript.context || ''} 
                                    onChange={(e) => setEditingScript({...editingScript, context: e.target.value})}
                                    className="w-full p-3 border border-[#FFBB98] rounded-xl"
                                />
                            </div>
                            <div>
                                <label className="text-sm text-[#7D8E95] mb-1 block">Role</label>
                                <select 
                                    value={editingScript.role} 
                                    onChange={(e) => setEditingScript({...editingScript, role: e.target.value})}
                                    className="w-full p-3 border border-[#FFBB98] rounded-xl"
                                >
                                    <option value="general">General</option>
                                    <option value="pursuer">Pursuer</option>
                                    <option value="withdrawer">Withdrawer</option>
                                </select>
                            </div>
                        </div>
                        <div className="flex gap-3 mt-6">
                            <TertiaryButton onClick={() => setEditingScript(null)} className="flex-1">Cancel</TertiaryButton>
                            <PrimaryButton onClick={() => onSave(editingScript)} className="flex-1">Save</PrimaryButton>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ScriptsTab;
